export const radiobuttonPreset = {
  root: ({ props }: any) => ({
    class: ['!w-[20px] !h-[20px]'],
  }),

  box: ({ props }: any) => ({
    class: [
      '!w-[20px] !h-[20px]',
      // Transition
      'transition-none',

      // Colors
      {
        'border-surface-200 dark:border-gray-700':
          props.value !== props.modelValue && props.value !== undefined && !props.invalid,
        'border-blue-700 dark:border-surface-200': props.value == props.modelValue && props.value !== undefined,
        'bg-blue-600': props.value == props.modelValue && props.value !== undefined,
      },
      {
        'peer-hover:border-primary dark:peer-hover:border-blue-400': !props.disabled && !props.invalid,
      },
    ],
  }),
};
